function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "close_svg__a",
  d: "M.42 2.5a1.5 1.5 0 010-2.08 1.5 1.5 0 012.08 0L15 12.93 27.5.42a1.46 1.46 0 112.06 2.08L17.07 15l12.49 12.5a1.46 1.46 0 11-2.06 2.08L15 17.07 2.5 29.58a1.5 1.5 0 01-2.08 0 1.5 1.5 0 010-2.08L12.91 15z"
});

function SvgClose(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 29.99 30"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/close.2028eae8.svg";
export { SvgClose as ReactComponent };